<template>
<div :style="style" class="ee-textarea">
  <span class="ee-textarea__title" v-if="title" ref="title">{{title}}</span>
  <textarea :placeholder="placeholder" :style="{textIndent: `${indent}px`}" class="ee-textarea__input" @input="handleChange" :value="value"></textarea>
  <span class="ee-textarea__tips" v-if="max > 0">还可以输入<i>{{maxLen}}</i>个字</span>
</div>
</template>
<script>
  export default {
    compName: 'ee-textarea',
    props: {
      placeholder: String,
      title: String,
      value: {
        type: String
      },
      width: {
        type: Number,
        default: 360
      },
      height: {
        type: Number,
        default: 135
      },
      max: {
        type: Number,
        default: -1
      }
    },
    methods: {
      handleChange (event) {
        const value = event.target.value
        if (this.max >= 0 && value.length <= this.max || this.max < 0) {
          this.$emit('input', event.target.value)
        } else {
          event.target.value = this.value
        }
      }
    },
    data () {
      return {
        indent: 0
      }
    },
    computed: {
      maxLen () {
        const len = this.value ? this.value.length : 0
        return this.max - len
      },
      style () {
        return {
          width: `${this.width}px`,
          height: `${this.height}px`
        }
      }
    },
    mounted () {
      if (this.title && this.$refs.title) {
        this.indent = this.$refs.title.offsetWidth + 10
      }
    }
  }
</script>
<style>
@import "../style/vars.css";
@component-namespace ee {
  @b textarea {
    position: relative;
    line-height: 1.2;
    border: 1px solid var(--border-color);
    margin-bottom: 24px;
    @e title {
      position: absolute;
      top: 10px;
      left: 10px;
      color: #666;
      background-color: #fff;
    }
    @e input {
      width: 100%;
      height: 100%;
      padding: 10px;
      border: 0 none;
      resize: none;
      line-height: 1.5;
    }
    @e tips {
      position: absolute;
      right: 20px;
      top: 100%;
      margin-top: 3px;
      font-size: 14px;
      color: #999;
      background-color: #fff;
      i {
        font-style: normal;
        color: #d33737;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/packages/textarea/Textarea.vue?75aba384